import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TrendingUp } from 'lucide-react';
import { scenarios, scenarioList } from '../services/scenarios';
import { useScenarioSessionStore } from '../stores/scenarioSessionStore';
import './HomePage.css';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const { sessionId, resetSession } = useScenarioSessionStore();
  const [hasActiveSession, setHasActiveSession] = useState(false);

  // Check if there's an active session on mount
  useEffect(() => {
    const checkActiveSession = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/getTranscript?sessionId=${sessionId}`);
        if (response.ok) {
          const transcript = await response.json();
          // Has active session if there are messages and conversation isn't finished
          setHasActiveSession(transcript.turns && transcript.turns.length > 0);
        } else {
          setHasActiveSession(false);
        }
      } catch (error) {
        setHasActiveSession(false);
      }
    };

    checkActiveSession();
  }, [sessionId]);

  const handleContinueSession = (): void => {
    navigate('/task');
  };

  const handleNewSession = (): void => {
    resetSession();
    setHasActiveSession(false);
  };

  const handleScenarioClick = (scenarioId: string): void => {
    const selectedScenario = scenarios[scenarioId];
    if (selectedScenario) {
      console.log(`Selected scenario: ${scenarioId}`);
      navigate('/task', { state: { scenario: selectedScenario } });
    }
  };

  const handleResultsClick = (): void => {
    navigate('/results');
  };

  return (
    <div className="scenarios-page">
      {/* Results toggle button */}
      <button 
        className="results-toggle-btn"
        onClick={handleResultsClick}
        title="Bekijk resultaten"
      >
        <TrendingUp size={24} />
      </button>

      <header className="scenarios-header">
        <h1>{hasActiveSession ? 'Actief gesprek' : 'Kies een scenario'}</h1>
      </header>
      
      <main className="scenarios-content">
        {hasActiveSession ? (
          <div className="active-session-container">
            <p>Je hebt een actief gesprek. Wil je doorgaan of een nieuw gesprek starten?</p>
            <div className="session-buttons">
              <button 
                className="continue-button"
                onClick={handleContinueSession}
              >
                Ga door met gesprek
              </button>
              <button 
                className="new-session-button"
                onClick={handleNewSession}
              >
                Start nieuw gesprek
              </button>
            </div>
          </div>
        ) : (
          <div className="scenarios-grid">
            {scenarioList.map((scenario) => (
              <div 
                key={scenario.id}
                className="scenario-card"
                onClick={() => handleScenarioClick(scenario.id)}
              >
              <div className="scenario-image">
                <img src={scenario.imageSrc} alt={scenario.title} />
              </div>
              <h2 className="scenario-title">{scenario.title}</h2>
            </div>
          ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default HomePage;